import { render, staticRenderFns } from "./update-password.vue?vue&type=template&id=f962ca10&scoped=true"
import script from "./update-password.vue?vue&type=script&lang=js"
export * from "./update-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f962ca10",
  null
  
)

export default component.exports